import React from "react";
import { BrowserRouter, Redirect, Switch, Route } from "react-router-dom";
import ExecucaoFiscal from "../views/ExecucaoFiscal";
import ConsultarDebitosV2 from "../views/v2/ConsultarDebitos";
import ConsultarProtestoV2 from "../views/v2/ConsultarProtesto";
import DuvidasFrequentes from "../views/DuvidasFrequentes";
import ConsultarParcelamentosV2 from "../views/v2/ConsultarParcelamentos";
import AtendimentosEspecializados from "../views/AtendimentosEspecializados";
import ValidarAssinaturaV2 from "../views/v2/ValidarAssinatura";
import AreaAtendente from "../views/AreaAtendente";
import LoginV2 from "../views/v2/Login";
import AdminLogin from "../views/v2/Admin/Login";
import AdminArea from "../views/v2/Admin";
import HomeV2 from '../views/v2/Home';
import QuemEQuemV2 from '../views/v2/QuemEQuem';
import LeisRegulamentadorasV2 from '../views/v2/LeisRegulamentadoras';
import ServicosV2 from '../views/v2/Servicos';
import APGMV2 from '../views/v2/APGM';
import ContatosV2 from "../views/v2/Contatos";
import TransparenciaV2 from "../views/v2/Transparencia";
import FaqV2 from "../views/v2/Faq";
import NoticiasV2 from "../views/v2/Noticias";
import ValeriaLopesV2 from "../views/v2/Noticias/ValeriaLopes";
import AtendimentoEmCasaV2 from "../views/v2/Noticias/AtendimentoEmCasa";
import FundefAcordoV2 from "../views/v2/Noticias/FundefAcordo";
import FundefFundebV2 from "../views/v2/Noticias/FundefFundeb";
import Pgm46AnosV2 from "../views/v2/Noticias/Pgm46Anos";
import PortalNovoV2 from "../views/v2/Noticias/PortalNovo";
import Refis2025V2 from "../views/v2/Noticias/Refis2025";
import TransacaoHotelariaV2 from "../views/v2/Noticias/TransacaoHotelaria";
import { VideoCall } from "../views/VideoCall";
import PagamentoPix from "../views/PagamentoPix";
import ErrorPage from "../views/v2/Error";

import { initGA } from "../analytics";

initGA();

export default function Router() {
  return (
    <BrowserRouter>
      <Switch>
        <Route path="/" exact component={HomeV2} />
        <Route path="/paineis/duvidas_frequentes" component={DuvidasFrequentes} />
        <Route path="/paineis/orientacoes_sobre_execucao_fiscal" component={ExecucaoFiscal} />
        <Route path="/atendimentos_especializados" component={AtendimentosEspecializados} />
        <Route path="/consultar/debitos/em_aberto" component={ConsultarDebitosV2} />
        <Route path="/consultar/parcelamentos" component={ConsultarParcelamentosV2} />
        <Route path="/consultar/protestos" component={ConsultarProtestoV2} />
        <Route path="/validar-documento" component={ValidarAssinaturaV2} />
        <Route path="/area_atendente" component={AreaAtendente} />
        <Route path="/contatos" component={ContatosV2} />
        <Route path="/duvidas" component={FaqV2} />
        <Route path="/login" component={LoginV2} />
        <Route path="/admin/login" component={AdminLogin} />
        <Route path="/admin" component={AdminArea} />
        <Route path="/noticias" component={NoticiasV2} />
        <Route path="/noticia" component={PortalNovoV2} />
        <Route path="/atendimento_sem_sair_de_casa" component={AtendimentoEmCasaV2} />
        <Route path="/transacao_tributaria" component={TransacaoHotelariaV2} />
        <Route path="/fundef_fundeb" component={FundefFundebV2} />
        <Route path="/refis_2025" component={Refis2025V2} />
        <Route path="/fundef_agreement" component={FundefAcordoV2} />
        <Route path="/valeria_lopes_publica_artigo_em_jornal" component={ValeriaLopesV2} />
        <Route path="/pgm_birthday" component={Pgm46AnosV2} />
        <Route path="/apgm" component={APGMV2} />
        <Route path="/quem_e_quem" component={QuemEQuemV2} />
        <Route path="/servicos" component={ServicosV2} />
        <Route path="/leis_regulamentadoras" component={LeisRegulamentadorasV2} />
        <Route path="/transparencia" component={TransparenciaV2} />
        <Route path="/pagamento/pix" component={PagamentoPix} />
        <Route path="/video_call/:balcaoId/:id" component={VideoCall} />
        <Route exact path="/:errorCode(404|500)" component={ErrorPage} />
        <Route path="*" render={() => <Redirect to="/404" />} />
      </Switch>
    </BrowserRouter>
  );
}
